"use client"
import {normalizePersianText} from "persian-normalizer";
import React, {memo, useId, useMemo, useState} from "react";
import {ProductGroupLevel, productGroupNames} from "@/types/product-group";
import {Field} from "@/components/form";
import ProductsFilterAccordion from "./products-filter-accordion";
import {useAppSelector} from "@/redux/hooks";
import ProductsFilterAccordionItem from "./products-filter-accordion-item";

import {useSelector} from "react-redux";
import {RootState} from "@/redux/store";
import {Box, Typography} from "@mui/material";
import {useTheme} from "@mui/material/styles";

function ProductsFilterByProductGroup({
                                                   title,
                                                   name,
                                                   type,
                                               }: {
    title: string;
    name: string;
    type: ProductGroupLevel;
}) {
    const theme = useTheme();
    const checkboxIdPrefix = useId().replace(/:/g, "");
    const productGroups = useSelector((state: RootState) => state.layout.productGroups);

    const [searchPhrase, setSearchPhrase] = useState("");
    const productGroup = useAppSelector(
        state => state.products[productGroupNames[type] as keyof typeof state.products] ?? []
    );


    const items = useMemo(() => {
        return productGroups?.filter((item) => item?.pLevel == type)
            .map((item) => ({
                ...item,
                isChecked: Array.isArray(productGroup) && productGroup.includes(+item?.id),
            }))
            .sort((a, b) => {
                const aName = normalizePersianText(a.name);
                const bName = normalizePersianText(b.name);
                return aName.localeCompare(bName, "fa");
            });
    }, [productGroups, productGroup]);

    const selectedItems = useMemo(() => items.filter((item) => item.isChecked), [items]);

    const checkedItems = useMemo(() => selectedItems.map((item) => item.name).join(", "), [selectedItems]);

    const count = selectedItems.length;


    return (
        <ProductsFilterAccordion
            title = {count > 0 ? `${title}` : title}
            active = {count > 0}
            subtitle = {checkedItems}
            name = {name}
        >
            <Field.Text
                sx = {{width: "100%", mb: 1}}
                placeholder = "جستجو..."
                size = "small"
                value = {searchPhrase}
                onChange = {(e) => setSearchPhrase(e.target.value)}
                closeIcon
                searchIcon
            />

            {selectedItems.length > 0 && (
                <Box >
                    <Typography fontSize = {14} color='grey.500' fontWeight = {300} my = {.5} >
                        انتخاب شما
                    </Typography >

                    {selectedItems.map((item) => (
                        <ProductsFilterAccordionItem
                            key = {`selected-${type}-${item.id}`}
                            checkboxId = {`product-filter-${checkboxIdPrefix}-selected-${type}-${item.id}`}
                            item = {item}
                            type = {type}
                        />
                    ))}
                </Box >
            )}

            <Box sx={{ mt: selectedItems.length > 0 ? 1.5 : 0 }}>
                {
                    selectedItems.length > 0 &&
                    <Typography
                        fontSize={14}
                        color="grey.500"
                        fontWeight={300}
                        my={0.5}
                    >
                      همه گزینه‌ها
                    </Typography>
                }

            {(searchPhrase == ""
                     ? items
                    : items.filter((item) =>
                        normalizePersianText(item.name).includes(
                            normalizePersianText(searchPhrase)
                        )
                    )
            ).map((item) => (
                <ProductsFilterAccordionItem
                    key = {`main-${type}-${item.id}`}
                    checkboxId = {`product-filter-${checkboxIdPrefix}-main-${type}-${item.id}`}
                    item = {item}
                    type = {type}
                />
            ))}
            </Box>
        </ProductsFilterAccordion >

    );
}

export default memo(ProductsFilterByProductGroup);
